import {Component} from 'react';
import PropTypes from 'prop-types';

import './media-play-video.less';
import {appConfigService, fileTypeService} from '_app/services';
import {Enums} from '_app/utils';
import VideoPlayer from '../shared/VideoPlayer';

export default class MediaPlayVideo extends Component {
	static propTypes = {
		media: PropTypes.object.isRequired,
		sourceLink: PropTypes.string,
		trackList: PropTypes.array,
		token: PropTypes.string,
		officeFooter: PropTypes.string,
		advisorDisclaimer: PropTypes.string,
		versionDisclaimer: PropTypes.string,
		complianceID: PropTypes.string,
		shareControl: PropTypes.element
	}

	formattedTracks() {
		if (!this.props.trackList) {
			return null;
		}
		const trackTypes = Enums.getType('trackTypes');
		const result = this.props.trackList
			.filter(function(item) {
				return item.keyText && item.keyText.length;
			})
			.map(function(item) {

				return {
					file: fileTypeService.videoTrackUrl(item.keyText),
					label: item.label,
					kind: trackTypes.properties[item.type].name.toLowerCase()
				};
			});

		return result;
	}

	videoPlayerOptions() {
		const {Type, ThumbnailLink, ExternalMediaID} = this.props.media;
		const {abmVideoBranding, logoUrl} = this.props.userInfo;
		const logo = abmVideoBranding ? {
			file: logoUrl,
			position: 'top-left',
			hide: true
		} : null;
		var thumbnailUrl = fileTypeService
			.thumbnailUrl(Type, ThumbnailLink, ExternalMediaID);
		var options = {
			file: fileTypeService.videoUrl(ExternalMediaID),
			mediaid: ExternalMediaID,
			image: thumbnailUrl,
			tracks: this.formattedTracks(),
			logo
		};

		return options;
	}

	getAdvisorDisclaimer() {
		return {
			__html: this.props.advisorDisclaimer.replace('<img src="/',`<img src="${appConfigService.get('baseDomainName')}/`)
		};
	}

	getOfficeFooter() {
		return {
			__html: this.props.officeFooter
		};
	}

	render() {
		var content = null;
		var video = null;

		if (this.props.media.ExternalMediaID) {
			video = (
				<div className="player-main" key="PLAY">
					<div className="player" ref={this.setRef}>
						<VideoPlayer options={this.videoPlayerOptions()} token={this.props.token} />
					</div>
					{this.props.sourceLink &&
					<div className="link-tag">
						<a href={this.props.sourceLink} target="_blank">
							<small>Sources</small>
						</a>
					</div>
					}
					<div className="video-info">
						<span className="video-name">{this.props.media.Name}</span>
						<span className="video-desc">{this.props.media.Description}</span>
					</div>
					{this.props.shareControl && this.props.shareControl}
				</div>
			);
			content = (
				<div className="main-section">
					{video}
				</div>
			);
		} else {
			content = (
				<div className="player-main">
					<div style={{
						margin: '40px'
					}}
					>Video Not Found</div>
				</div>
			);
		}
		return (
			<div className="media-view-container">
				{content}
			</div>
		);
	}
}